import * as React from "react";
import { IntegrationCategories } from "src/components/template/constants";
import useTemplateDataApi from "src/hooks/use-template-data-api";
import TemplateItem from "src/components/template/template-item";
import type { TemplateItemInterface } from "src/components/template/types";
import { Stack } from "@mui/material";
import { useParams } from "react-router-dom";

const TemplateItemSample = ({ item }: { item: TemplateItemInterface }) => {
    const { teamId } = useParams();
    const [mouseIn, setMouseIn] = React.useState(false);
    const fetchAction = useTemplateDataApi({
        template: {
            id: "string",
            title: { value: "string" },
            dependencies: [IntegrationCategories.git],
            rows: [{ items: [item] }],
        },
        defaultDateRange: "week",
        variables: {},
        isSample: true,
        teamId,
    });
    return (
        <div
            style={{ position: "relative" }}
            onMouseEnter={() => {
                setMouseIn(true);
            }}
            onMouseLeave={() => {
                setMouseIn(false);
            }}
        >
            {mouseIn && (
                <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    style={{
                        backgroundColor: "#474747",
                        position: "absolute",
                        zIndex: 101,
                        opacity: 0.4,
                        inset: 0,
                        borderColor: "#60D297",
                        borderWidth: "2px",
                        borderStyle: "dashed",
                    }}
                >
                    <span style={{ fontSize: "1rem", paddingTop: "10px", fontWeight: "300" }}>
                        Sample
                    </span>
                </Stack>
            )}
            <TemplateItem
                viewType={teamId ? "team" : "repo"}
                item={{
                    ...item,
                    ...("sizing" in item && { sizing: { ...item.sizing, md: 12, xs: 12 } }),
                }}
                fetchAction={fetchAction}
                {...(teamId && { teamApi: {} })}
                rowIndex={0}
                itemIndex={0}
                templateIndex={0}
                itemCount={1}
                top={false}
                bottom={false}
                context={{}}
                isSample
            />
        </div>
    );
};

export default TemplateItemSample;
